"use client";

import { BdAltArrowLeft } from "solar-icon-react/bd";
import React from "react";
import { cn, formatNumberWithDots } from "@/lib";
import { IPackages } from "@/interfaces";
import { CustomButton } from "../ui";

type Props = {
  pkg: IPackages;
  onClick?: () => void;
};

const PackageCard: React.FC<Props> = ({ pkg, onClick }) => {
  return (
    <div
      className={cn(
        "shadow-main relative overflow-hidden rounded-[10px] pt-1 transition-all duration-300 hover:scale-103",
      )}
      style={{
        backgroundColor:
          !pkg.purchased && pkg.is_active ? pkg.color : "oklch(70.8% 0 0)",
      }}
    >
      <div className="relative z-0 rounded-[9px] bg-white select-none">
        <div className="flex h-full min-h-[390px] flex-col justify-between gap-2 px-3 py-6">
          <span
            className={cn(
              "text-center text-base font-bold lg:text-lg",
              pkg.purchased || !pkg.is_active ? "text-gray-400" : "",
            )}
          >
            {pkg.title}
          </span>
          <p
            className={cn(
              "py-1 text-center text-sm",
              pkg.purchased || !pkg.is_active ? "text-gray-400" : "",
            )}
          >
            {pkg.duration}
          </p>
          <span
            className={cn(
              "text-xs font-bold",
              pkg.purchased || !pkg.is_active ? "text-gray-400" : "",
            )}
          >
            سرویس‌های قابل استفاده با خرید این بسته
          </span>

          <ul className="mt-2 flex flex-col gap-1">
            {pkg.services.map((s, i) => (
              <li
                key={i}
                className={cn(
                  "flex items-center",
                  pkg.purchased || !pkg.is_active
                    ? "text-gray-400"
                    : "text-gray-700",
                )}
                style={{ transitionDelay: `${i * 30}ms` }}
              >
                <BdAltArrowLeft
                  className={cn(
                    pkg.purchased || !pkg.is_active
                      ? "text-gray-400"
                      : "text-primary-main",
                  )}
                />
                <span className="text-xs">{s}</span>
              </li>
            ))}
          </ul>

          <p
            className={cn(
              "my-2 text-center text-xl font-bold lg:text-2xl",
              pkg.purchased || !pkg.is_active ? "text-gray-400" : "",
            )}
          >
            {`${formatNumberWithDots(pkg.price)} ت`}
          </p>

          <p
            className={cn(
              "text-center text-[11px]",
              pkg.purchased || !pkg.is_active
                ? "text-gray-400"
                : "text-red-700",
            )}
          >
            <b>{pkg.discount}</b>
            {pkg.perInquiryPrice
              ? ` | هر استعلام ${formatNumberWithDots(pkg.perInquiryPrice)} تومان`
              : null}
          </p>

          <CustomButton
            onClick={onClick}
            variant="primary"
            className={cn("mx-auto mt-3 w-max")}
            disabled={pkg.purchased || !pkg.is_active}
          >
            خرید بسته
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
